import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from 'src/app/main/app.component';
import {appConfig} from 'src/app/main/app.config';
bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err))
